<header>
	<h1 i18n>Запрос статуса</h1>
	<app-svg assetsPath="close" (click)="close$.next()"></app-svg>
</header>
<section>
	<span i18n>{{ statusText }}</span>
</section>
<footer>
	<button (click)="close$.next()" i18n>Закрыть</button>
</footer>
